import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpConfirm', pkpConfirm);

    /**
     * @author bjnowak.btc
     * @ngInject
     */
    function pkpConfirm() {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                id: '@',
                label: '@',
                onConfirm: '&',
                onClose: '&',
                hideTrash: '=?',
                disabledSend: '<'
            },
            template: require('app/_directives/pkp-confirm.directive.html'),
            link: ConfirmModalLink
        };

        function ConfirmModalLink(
            scope,
            elem: JQLite,
            attr,
            ctrl,
            transclude: ng.ITranscludeFunction
        ) {
            transclude(scope.$parent, (clone) => (scope.transclusion = clone));
        }
    }
})();
